// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {"485": "e3d5a8eb15c23ef4","524": "e6d47d873fb18656",}[chunkId] + ".css"
}